import { makeRequest } from '~shared/api/make-request';
import { config } from '~shared/config';

import type { CheckReportStatusResponse } from '../model/check-report-status-response';

const BASE_URL = `${config.apiHost}/merchant-portal/api/v1/public/dashboard`;

export async function checkReportStatus(
  reportId: string
): Promise<CheckReportStatusResponse> {
  const res = await makeRequest<{ payload: CheckReportStatusResponse }>({
    httpMethod: 'POST',
    type: 'json',
    url: `${BASE_URL}/check-report-status`,
    withCredentials: true,
    timeout: 60_000,
    payload: { reportId },
  });
  return res.payload;
}

export async function downloadReport(reportId: string): Promise<ArrayBuffer> {
  return makeRequest<ArrayBuffer>({
    httpMethod: 'POST',
    type: 'json',
    url: `${BASE_URL}/download-report`,
    withCredentials: true,
    timeout: 5 * 60 * 1000,
    responseType: 'arrayBuffer',
    payload: { reportId },
  });
}
